<template>
  <div id="app">
    <!-- the router outlet, where all matched components would ber viewed -->


    <!-- Modal -->
    <!--<modal :showModal="showModal" :closeAction="closeModal" :containerClass="'offline'">
        <h3 slot="header">Summer Vacation Alert! 🌞🏖️</h3>
        <div class="row" slot="body">
          <div class="col-md-12">
            <p style="font-size:120%">Hey there, awesome customers! Just a quick heads up: our support team is off on summer vacation in August. We'll still be here to help, but we might not be as speedy as usual. Thanks for understanding! 😄🍹</p>
          </div>
        </div>
    </modal>-->

    
  <div class="bd-navbar">
    <!-- header only for authenticated user-->
    <header class="topbar clearfix" style="padding-top: 0px !important; box-shadow: 0 0px 5px rgba(0, 0, 0, 0.16) !important;" v-if="user.authenticated && !freeproduct">
      <div class="container">
        <!--Topbar Left Branding With Logo Start-->
        <div class="topbar-left pull-left col-md-4">
          <div class="clearfix">
            <ul class="left-branding pull-left clickablemenu ttmenu dark-style menu-color-gradient">
              <li>
                <div class="logo">
                  <a href="/" title="Audio Modeling"><img src="/static/images/logo-am.png" class="img-responsive" style="width:120px; margin-top:5px;" alt="Audio Modeling"></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!--Topbar Left Branding With Logo End-->
        <div class="col-lg-4 col-lg-offset-1 col-md-4 hidden-sm hidden-xs" style="padding-top: 10px;">
          <h4 class="col-lg-offset-2" style="font-weight: bold;">Audio Modeling Customer Portal</h4>
        </div>
        <!--Topbar Right Start-->
        <div class="topbar-right pull-right bar-toggle col-md-4">
          <div class="clearfix">
            <!--Mobile View Leftbar Toggle-->
            <ul class="left-bar-switch pull-left">
              <li>
                <a href="/" title="Audio Modeling"><img class="img-responsive" style="width:120px; margin-top:5px;" ssrc="/static/images/logo-am.png" alt="Audio Modeling"></a>
              </li>
            </ul>
            <ul class="pull-right top-right-icons">
              <li class="dropdown apps-dropdown">
                {{ utente.username }} <a href="#" class="btn-apps dropdown-toggle" data-toggle="dropdown"><i class="zmdi zmdi-menu"></i></a>
                <div class="dropdown-menu" style="z-index:9999999999">
                  <ul class="more-apps">
                    <li style="border-top:0px;"><a href="javascript:void(0)" @click="goHome('all')"><i class="zmdi zmdi-home"></i>All catalogue</a></li>
                    <li><a href="javascript:void(0)" @click="goHome('your')"><i class="zmdi zmdi-collection-item"></i>Your Products</a></li>
                    <li><a href="javascript:void(0)" @click="goHome('only')"><i class="zmdi zmdi-star"></i>Only for you</a></li>
                    <li><a href="javascript:void(0)" @click="goHome('only')"><i class="zmdi zmdi-download"></i> Install and Update</a></li>
                    <li class="hidden-lg"><a href="javascript:void(0)" @click="goAddOrder()"><i class="zmdi zmdi-collection-plus "></i> Register a new product</a></li>
                    <li><a href="javascript:void(0)" @click="goHomeTransactions()"><i class="zmdi zmdi-time"></i> Purchase history</a></li>
                    <!--                    <li><a :href="this.shop" target="_blank"><i class="zmdi zmdi-shopping-basket"></i>Shop</a></li>-->
                    <li><a href="https://support.audiomodeling.com" target="_blank"><i class="zmdi zmdi-help-outline "></i> FAQs & Support</a></li>
                    <li><a href="javascript:void(0)" @click="goSettings()"><i class="zmdi zmdi-account "></i> Account settings</a></li>
                    <li><a :href="this.website" target="_blank"><i class="zmdi zmdi-globe"></i>Website</a></li>
                    <li><a :href="this.community" target="_blank"><i class="zmdi zmdi-comments"></i>Community</a></li>
                    <li><router-link to="/logout"><i class="zmdi zmdi-close-circle"></i> Logout</router-link></li>
                  </ul>
                </div>
              </li>
              <li><a href="javascript:void(0)" @click="openCart()" class="btn-apps"><i class="zmdi zmdi-shopping-cart"></i><span class="badge badge-notify">{{cart}}</span></a></li>
            </ul>
          </div>
        </div>
        <!--Topbar Right End-->
      </div>

    </header>
    <!-- Registration product bar -->
    <header class="topbar clearfix hidden-sm hidden-xs" style="padding-top: 0px !important; box-shadow: 0 2px 0px rgba(0, 0, 0, 0.16); !important; background-color: #17bab8" v-if="user.authenticated && !keysRoute && $route.fullPath !== '/keys' && $route.fullPath !== '/add-order' && !freeproduct">
      <div class="container">
        <div class="row" style="padding-right: 5px; padding-left: 5px;">
          <div class="col-lg-3 col-md-2">
            <h3 class="hidden-md" style="color: #ffffff; font-size:110%">NEW PRODUCT REGISTRATION</h3>
            <h6 class="hidden-lg" style="color: #ffffff; font-size:90%">NEW PRODUCT REGISTRATION</h6>
          </div>
          <div class="col-lg-6 col-md-8">
            <div class="input-group input-group-lg" style="width: 100%;">
              <input type="text" class="form-control" placeholder="Paste your License Key or Redeem Code here" style="width: 100%; margin-top:7px" v-model="code">
            </div>
          </div>
          <div class="col-lg-3 col-md-2">
            <div class="btn-group input-group-lg" style="width: 150px;">
              <button type="button" style="border-style: solid; border-color: #ffffff; background-color: unset; color: #ffffff; width: 100%; margin-top:7px; height: 45px;" @click="register()">REGISTER</button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- Registration product bar End -->
  </div>

    <router-view></router-view>
    <div v-if="user.authenticated" class="banner-red">
      <p>33% off on all  (excluding SWAM String Sections) with code <span style="font-weight:bolder">BF23</span> at checkout</p>
    </div>

    

  </div>
</template>
<style scoped>
.centered-am{

}
.bd-navbar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1000;
}
.badge-notify{
   width:16px;
   height:16px;
   text-align: center;
   margin: auto;
   background:red;
   position:absolute;
   top: 10px;
   right: 0px;
   padding: 2px
}
</style>
  <script>
  import auth from './auth/'
  import {router} from './main'
  import Modal from 'modal-vue'
  export default {
    components: { Modal },
    data() {
      return {
        showModal: true,
        user: auth.user,
        fastspring_user: '',
        cart: 0,
        code: '',
        get utente(){
          return JSON.parse(localStorage.getItem('userdata')) || 0;
        },
        get website(){
          return process.env.WEBSITE;
        },
        get shop(){
          return process.env.SHOP;
        },
        get community(){
          return process.env.COMMUNITY;
        },
        keysRoute: false,
        freeproduct: false
      }
    },
    computed: {
      totalProducts(){
        return
        //return 0;
        //return this.$root.cart.length;
      }
    },
    methods: {
      closeModal(){
          this.showModal = false
      },
      goAddOrder(){
       router.push('/add-order');
      },
      goSettings(){
       router.push('/settings');
      },
      goHome(type = ''){
        localStorage.setItem('userhome', 'products')
          localStorage.setItem('typetab', type)
          //router.push('/');
        window.location.href = '/'
      },
      /*goHome(){
        localStorage.setItem('userhome', 'products')
        router.push('/');
      },*/
      goHomeTransactions(){
        localStorage.setItem('userhome', 'transaction')
        router.push('/transactions');
      },
      openCart(){
        if(window['TwoCoInlineCart'].products.list.length > 0){
          window['TwoCoInlineCart'].cart.checkout()
        }
      },
      register(){
        let keyProduct = this.code
        //this.code = ''
        if(this.$route.name === 'addOrder') {
          //window.location.href = '/addOrder?keyProduct='+keyProduct
          router.push({path: 'add-order', query: { redeem_code: keyProduct }})
        } else {
          router.push({name: 'addOrder', params: { redeem_code: keyProduct }})
        }
        //router.push({name: 'addOrder', params: { redeem_code: keyProduct }})
      },
      checkKeyRoutes(){
        if(this.$route.fullPath.includes('keys') || this.$route.fullPath.includes('Keys') || this.$route.fullPath.includes('KEYS')){
          this.keysRoute = true;
        } else {
          this.keysRoute = false;
        }
      }
    },
    mounted() {
      let twoCheckoutScript = document.createElement('script')
      var vm = this;
      twoCheckoutScript.setAttribute('src', 'https://secure.avangate.com/checkout/client/twoCoInlineCart.js')
      document.head.appendChild(twoCheckoutScript)
      twoCheckoutScript.onload = function () {
        window['TwoCoInlineCart'].setup.setMerchant('250312169741');
        window['TwoCoInlineCart'].setup.setIframeLoad('checkout');
        window['TwoCoInlineCart'].register();
        //console.log('TwoCoInlineCart',window['TwoCoInlineCart'])

        setInterval(function(){
          vm.cart = window['TwoCoInlineCart'].products.list.length;
        }, 1000);
      }
    },
    beforeMount() {
      if(this.$route.params.token) this.freeproduct = true
      this.checkKeyRoutes();
    }
  }
  </script>
  <style>
  .banner-red p{
  font-family: "Helvetica Neue", Arial, sans-serif;
  margin-top:10px;
}
.banner-red{
  /*display:none;*/
  height:80px;
  width:100%;
  position:fixed;
  bottom:0px;
  background-color:#c9302c;
  color:#fff;
  font-size:30px;
  font-weight:500;
  z-index:999;
  cursor:pointer;

}
.container{
  margin-bottom:80px;
}
  </style>




// WEBPACK FOOTER //
// src/App.vue